module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-coins-xs-150602194daaf4a7e8c76a17ea5bc79b.svg";